import script from "./pwaAntiBlockingPopup.vue?vue&type=script&setup=true&lang=ts"
export * from "./pwaAntiBlockingPopup.vue?vue&type=script&setup=true&lang=ts"

import "./pwaAntiBlockingPopup.vue?vue&type=style&index=0&id=61c4fc10&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-61c4fc10"]])

export default __exports__